import { createContext, useContext, useEffect, useState, useMemo } from 'react';
import defaults from 'lodash/defaults';

const initialPageConfig = {
  title: undefined,
  hideBackButton: false,
};

const PageConfigContext = createContext(null);

// wrapper for the provider
export const PageConfigProvider = ({ children }) => {
  const [pageConfig, setPageConfig] = useState(initialPageConfig);

  const value = useMemo(() => ({
    pageConfig,
    setPageConfig,
  }), [pageConfig, setPageConfig]);
  return (
    <PageConfigContext.Provider value={value}>
      {children}
    </PageConfigContext.Provider>
  );
};

// custom hook
export const usePageConfig = () => useContext(PageConfigContext);
export const useSetPageConfig = (pageConfig) => {
  const { setPageConfig } = usePageConfig();
  useEffect(() => {
    setPageConfig((current) => defaults(pageConfig, current));
    return () => {
      setPageConfig(initialPageConfig);
    };
  }, [pageConfig, setPageConfig]);
};
